<template>
  <BaseModal :title :show-close="false" :is-open description="">
    <div v-if="inProgress">
      <PageLoading />
    </div>
    <div v-else>
      <p v-if="errorMessage" class="warning-color">
        <code>
          {{ errorMessage }}
        </code>
      </p>
    </div>
    <template v-if="!inProgress" #actions>
      <BaseButton variant="outlined" @click="close">Close</BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import BaseButton from "@/components-ng/BaseButton.vue";
import BaseModal from "@/components-ng/BaseModal.vue";
import PageLoading from "@/components-ng/PageLoading.vue";

export default {
  name: "ReloadWorkspaceModal",
  components: { BaseModal, BaseButton, PageLoading },
  props: {
    errorMessage: { type: String, required: false, default: null },
    done: { type: Boolean, required: true },
    isOpen: { type: Boolean, required: true },
  },
  emits: ["close"],
  computed: {
    inProgress() {
      return !this.done;
    },
    title() {
      if (this.done && this.errorMessage) {
        return "Reloading status and workflows failed.";
      }
      if (this.done) {
        return "Status and workflows reloaded. You can close this dialog.";
      }
      // loading
      return "Reloading status and workflows. Please do not close this dialog.";
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/colors" as c;

.warning-color {
  color: c.$brand-danger;
}
</style>
